const state = {
  token: localStorage.getItem('Medical-Token') || '',
  id: localStorage.getItem('Medical-UserId') || '',
  username: localStorage.getItem('Medical-Username') || '',
  nickname: localStorage.getItem('Medical-Nickname') || '',
  avatar: localStorage.getItem('Medical-Avatar') || '',
  role: localStorage.getItem('Medical-Role') || 'staff',
  orgName: localStorage.getItem('Medical-OrgName') || '',
  permissions: JSON.parse(localStorage.getItem('Medical-Permissions') || '[]'),
  roles: JSON.parse(localStorage.getItem('Medical-Roles') || '["staff"]'),
  userInfo: JSON.parse(localStorage.getItem('Medical-UserInfo') || '{}')
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('Medical-Token', token)
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    state.id = userInfo.userId || ''
    state.username = userInfo.username || ''
    state.nickname = userInfo.realName || ''
    state.avatar = userInfo.avatar || ''
    state.role = userInfo.roleType || 'staff'
    state.orgName = userInfo.orgName || ''
    
    localStorage.setItem('Medical-UserId', state.id)
    localStorage.setItem('Medical-Username', state.username)
    localStorage.setItem('Medical-Nickname', state.nickname)
    localStorage.setItem('Medical-Avatar', state.avatar)
    localStorage.setItem('Medical-Role', state.role)
    localStorage.setItem('Medical-OrgName', state.orgName)
    localStorage.setItem('Medical-UserInfo', JSON.stringify(userInfo))
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
    localStorage.setItem('Medical-Roles', JSON.stringify(roles))
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
    localStorage.setItem('Medical-Permissions', JSON.stringify(permissions))
  },
  CLEAR_TOKEN: (state) => {
    state.token = ''
    state.userInfo = {}
    state.id = ''
    state.username = ''
    state.nickname = ''
    state.avatar = ''
    state.role = 'staff'
    state.orgName = ''
    state.permissions = []
    state.roles = ['staff']
    
    localStorage.removeItem('Medical-Token')
    localStorage.removeItem('Medical-UserId')
    localStorage.removeItem('Medical-Username')
    localStorage.removeItem('Medical-Nickname')
    localStorage.removeItem('Medical-Avatar')
    localStorage.removeItem('Medical-Role')
    localStorage.removeItem('Medical-OrgName')
    localStorage.removeItem('Medical-Permissions')
    localStorage.removeItem('Medical-Roles')
    localStorage.removeItem('Medical-UserInfo')
  }
}

const actions = {
  // SSO登录（一表通回调后）
  ssoLogin({ commit }, loginData) {
    return new Promise((resolve, reject) => {
      try {
        const { token, userInfo } = loginData
        commit('SET_TOKEN', token)
        commit('SET_USER_INFO', userInfo)
        commit('SET_ROLES', userInfo.authorities || [userInfo.roleType || 'staff'])
        commit('SET_PERMISSIONS', userInfo.authorities || [])
        resolve({ token, userInfo })
      } catch (err) {
        reject(err)
      }
    })
  },
  
  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.token) {
        reject(new Error('未登录'))
        return
      }
      
      const userInfo = state.userInfo
      if (userInfo && userInfo.userId) {
        resolve(userInfo)
      } else {
        reject(new Error('用户信息不存在，请重新通过一表通登录'))
      }
    })
  },
  
  // 登出
  logout({ commit }) {
    return new Promise(resolve => {
      commit('CLEAR_TOKEN')
      resolve()
    })
  },
  
  // 跳转到一表通SSO登录
  redirectToSso() {
    import('@/api/auth').then(({ getSsoLoginUrl }) => {
      getSsoLoginUrl().then(ssoUrl => {
        if (ssoUrl) {
          window.location.href = ssoUrl
        } else {
          window.location.href = '/sso'
        }
      }).catch(() => {
        window.location.href = '/sso'
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}